import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router';
import { cn } from '../../lib/helpers';
import { LectureCategory } from '../../lib/types.ts';
import { colorVariant } from '../../lib/colors.ts';
import { IconLock } from '../Icon.tsx';

interface SubCategoryCardProps {
    lectureCategory: LectureCategory;
    showBadge: boolean;
    children?: React.ReactNode;
}

export default function SubCategoryCard({
    lectureCategory: {
        name,
        slug,
        color,
        poster,
        description,
        is_locked: isLocked,
        parent,
    },
    showBadge,
    children,
}: SubCategoryCardProps) {
    return (
        <div>
            <Link to={isLocked ? '#' : `/cviceni/lekce/${slug}`}>
                <div
                    className={cn(
                        'relative rounded-3xl bg-white shadow-sm transition-shadow',
                        !isLocked && 'hover:shadow-md',
                        isLocked && 'cursor-not-allowed'
                    )}
                >
                    {/* badge */}
                    {showBadge && (
                        <div
                            className={clsx(
                                'absolute right-0 top-0 rounded-bl-2xl rounded-tr-2xl px-4 py-1 text-sm text-white',
                                colorVariant(color).bar
                            )}
                        >
                            {parent?.name}
                        </div>
                    )}

                    {/* vertical line */}
                    <div
                        className={clsx(
                            'absolute left-0 top-[15%] h-[70%] w-1 flex-shrink-0 self-center rounded-r-md',
                            colorVariant(color).bar
                        )}
                    />

                    {/* card body */}
                    <div
                        className={clsx(
                            'grid grid-cols-[7.25rem_2fr] items-center gap-6 rounded-3xl p-6',
                            'bg-gradient-to-r',
                            colorVariant(color).card
                        )}
                    >
                        <div className="relative flex h-28 max-w-28 self-center">
                            {/*{isLocked && (*/}
                            {/*    <IconLock size={24} className="text-ink-700" />*/}
                            {/*)}*/}

                            {poster ? (
                                <img
                                    src={poster}
                                    className="h-full w-full rounded-xl object-contain object-center"
                                />
                            ) : (
                                <div className="h-full w-full rounded-xl bg-black/10" />
                            )}

                            {isLocked ? (
                                <div className="absolute inset-0 z-30 flex h-full w-full flex-col items-center justify-center rounded-2xl bg-black/50 backdrop-blur-sm">
                                    <IconLock
                                        size={64}
                                        className="text-cloud-100"
                                    />
                                </div>
                            ) : null}

                            {children}
                        </div>
                        <div>
                            <h4 className="">{name}</h4>
                            <p className="line-clamp-2 font-normal text-ink-800">
                                {description}
                            </p>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}
